<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="currentPage=1,searchQuery()">查询</el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button type="primary" @click="$router.push({path:'addgroup'})" >新增团购</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="70">
        </el-table-column>
        <el-table-column
          label="用户昵称"
          prop="buyer.account">
        </el-table-column>
        <el-table-column
          label="分类">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.orderType =='1'" type="text" >单人购</el-button>
            <el-button size="mini" v-if="scope.row.orderType =='2'" type="text" >三人拼团</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="团购名称"
          prop="orderTitle">
        </el-table-column>
        <el-table-column
          label="付费金额"
          prop="orderAmountActual">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          label="付费时间"
          prop="insertTime">
          <template slot-scope="scope">
            <span>{{scope.row.insertTime | formatDate}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getorder } from "../api/api"
  import { formatDate } from "../api/formatDate"
  export default {
    data () {
      return {
        value: '0',
        filters: {
          name: ''
        },
        options:[{
          value: '0',
          label: '全部',
        }, {
          value: '1',
          label: '单人购',
        }, {
          value: '2',
          label: '三人拼团',
        }],
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
      }
    },
    components: {
      headTop,
    },
    filters: {
      formatDate(time) {
        var date = new Date(time*1000);
        return formatDate(date, 'yyyy-MM-dd h:m:s');
      }
    },
    methods: {
      //时间戳转换
      formatDate: function (value) {
        var dateee = new Date(value.insertTime).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.searchQuery()
      },
      searchQuery () {
        let params = {
          currPage: this.currentPage,
          pageLimit: this.limit,
          orderType:this.value,
          direction:'desc',
          properties:'id',
          orderStatus:2
        };
        getorder(params).then(res => {
          this.tableData = res.data.list
          this.total = res.data.totalCount
        }).catch(error => {
          console.log(error);
        })
      },
    },
    created (){
      this.searchQuery()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/page/order.vue